// ── Demand Planning ──────────────────────────────────────────────────────────
export const FEATURE_FLAG_DEMAND_PLANNING = 'll.demandPlanning.module';
export const FEATURE_FLAG_DEMAND_FORECASTING = 'll.demandPlanning.demandForecasting';
export const FEATURE_FLAG_DEMAND_PREDICTION = 'll.demandPlanning.demandPrediction';

// ── Inventory Optimization ───────────────────────────────────────────────────
export const FEATURE_FLAG_INVENTORY_OPTIMIZATION = 'll.inventoryOptimization.module';
export const FEATURE_FLAG_ABC_ANALYSIS = 'll.inventoryOptimization.abcAnalysis';
export const FEATURE_FLAG_CONSTRAINED_SERVICE_LEVEL_OPTIMIZATION = 'll.inventoryOptimization.constrainedServiceLevelOptimization';
export const FEATURE_FLAG_LEAD_TIME_PREDICTION = 'll.inventoryOptimization.leadTimePrediction';
export const FEATURE_FLAG_LEAD_TIME_PREDICTION_RULES = 'll.inventoryOptimization.leadTimePrediction.rules';
export const FEATURE_FLAG_LEAD_TIME_PREDICTION_VALUE_METRIC = 'll.inventoryOptimization.leadTimePrediction.valueMetric';
export const FEATURE_FLAG_OPTIMAL_REPLENISHMENT_QUANTITY = 'll.inventoryOptimization.optimalReplenishmentQuantity';
export const FEATURE_FLAG_SUPPLY_VARIABILITY = 'll.inventoryOptimization.supplyVariability';

// ── AI ───────────────────────────────────────────────────────────────────────
export const FEATURE_FLAG_DEO_AGENT = 'll.ai.deoAssist';
export const FEATURE_FLAG_DEO_AGENT_FEEDBACK = 'll.ai.deoAssist.feedback';
export const FEATURE_FLAG_DEO_AGENT_LIVE_TRANSCRIPTION = 'll.ai.deoAssist.liveTranscription';
export const FEATURE_FLAG_DEO_AGENT_RENAME_CHAT = 'll.ai.deoAssist.renameChat';
export const FEATURE_FLAG_DEO_AGENT_PROJECTS = 'll.ai.deoAssist.projects';
export const FEATURE_FLAG_DEO_AGENT_PROJECT_INSTRUCTIONS = 'll.ai.deoAssist.projectInstructions';
export const FEATURE_FLAG_DEO_AGENT_ATTACH_FILE = 'll.ai.deoAssist.attachFile';
export const FEATURE_FLAG_DEO_AGENT_STOP_BUTTON = 'll.ai.deoAssist.stopButton';
export const FEATURE_FLAG_DEO_AGENT_TALKING_TO = 'll.ai.deoAssist.talkingTo';
export const FEATURE_FLAG_DEO_AGENT_CONVERSATION_CHIPS = 'll.ai.deoAssist.conversationChips';

// ── Home ─────────────────────────────────────────────────────────────────────
export const FEATURE_FLAG_HOME = 'll.home';

// ── Favorites ────────────────────────────────────────────────────────────────
export const FEATURE_FLAG_FAVORITES = 'll.favorites';

// ── DEFAULT SETTINGS ─────────────────────────────────────────────────────────
export const FEATURE_FLAG_DEFAULT_SETTINGS = 'll.defaultSettings';

// ── ACCESS CONTROL ───────────────────────────────────────────────────────────
export const FEATURE_FLAG_ACCESS_CONTROL = 'll.accessControl';

// ── PERSONAL SETTINGS ────────────────────────────────────────────────────────
export const FEATURE_FLAG_PERSONAL_SETTINGS = 'll.personalSettings';

// ── NOTIFICATION ─────────────────────────────────────────────────────────────
export const FEATURE_FLAG_NOTIFICATION = 'll.notification';

// ── TOOLS ────────────────────────────────────────────────────────────────────
export const FEATURE_FLAG_TOOLS = 'll.tools';

// ── AGENT LIBRARY ────────────────────────────────────────────────────────────
export const FEATURE_FLAG_AGENT_LIBRARY = 'll.agentLibrary';
